import React, { useState } from 'react';
import { strings } from '@purple-start-registration/common/localization';

import { formatHTML } from '@purple-start-registration/common/price';

export function EventList({ config, data, onSelectionChange }) {
  const { settings, events } = config;
  const [checkedState, setCheckedState] = useState(
    new Array(events.length).fill(false)
  );

  /**
   * Notify the parent component that an event was selected.
   */
  const notifyParent = (state) => {
    onSelectionChange(
      state
        .map((selected, index) => selected && events[index].code)
        .filter((event) => !!event)
    );
  };

  /**
   * Select a single event.
   */
  const handleOnChange = (position) => {
    const state = checkedState.map((item, index) =>
      index === position ? !item : item
    );

    setCheckedState(state);
    notifyParent(state);
  };

  /**
   * Select all events.
   */
  const handleCheckAll = (e) => {
    e.preventDefault();

    const state = events.map((s) => {
      if (s.full) {
        return false;
      }

      return true;
    });
    setCheckedState(state);
    notifyParent(state);
  };

  return (
    <div className="md:grid md:grid-cols-3 md:gap-6">
      <div className="md:col-span-1">
        <div className="px-4 sm:px-0">
          <h3 className="text-lg font-medium leading-6 text-gray-900 rsca-title">
            {config.getTranslation('events_sidebar_title', data.language) ||
              config.getTranslation('events_title', data.language) ||
              strings.eventsTitle}
          </h3>
          <p className="mt-1 text-sm text-gray-600 rsca-title">
            {config.getTranslation(
              'events_sidebar_description',
              data.language
            ) || strings.eventsDescription}
          </p>
        </div>
      </div>
      <div className="mt-5 md:mt-0 md:col-span-2">
        <div className="shadow overflow-hidden sm:rounded-md">
          <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
            <fieldset>
              <div>
                <legend className="text-base font-medium text-gray-900">
                  {config.getTranslation('events_form_title', data.language) ||
                    strings.eventsFormTitle}
                </legend>
                <p
                  className="mt-1 text-sm text-gray-700"
                  dangerouslySetInnerHTML={{
                    __html: strings.formatString(
                      config.getTranslation(
                        'events_form_description',
                        data.language
                      ) || strings.eventsFormDescription,
                      settings.discount_min_2 &&
                        formatHTML(settings.discount_min_2),
                      settings.discount_min_3 &&
                        formatHTML(settings.discount_min_3)
                    ),
                  }}
                />
              </div>
              <div className="mt-4 space-y-4">
                {events.map((event, index) => {
                  const name = event[`name_${data.language}`];

                  return (
                    <div key={event.code} className="relative flex items-start">
                      <div className="flex items-center h-5">
                        <input
                          id={event.code}
                          type="checkbox"
                          name={event.code}
                          disabled={event.full}
                          checked={checkedState[index]}
                          className="focus:ring-purple-500 h-4 w-4 text-purple-600 border-gray-300 rounded"
                          onChange={() => handleOnChange(index)}
                        />
                      </div>
                      <div className="ml-3 text-sm">
                        <label htmlFor={event.code} className="text-gray-700">
                          {(event.full && (
                            <span className="text-gray-400">
                              {name}
                              <span className="ml-1">
                                ({strings.fullyBooked})
                              </span>
                            </span>
                          )) || (
                            <>
                              {name}
                              <span
                                className="ml-1"
                                dangerouslySetInnerHTML={{
                                  __html: `(<strong>${formatHTML(
                                    event.price
                                  )}</strong>)`,
                                }}
                              ></span>
                            </>
                          )}
                        </label>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  onClick={handleCheckAll}
                  className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
                >
                  {config.getTranslation('select_all', data.language) ||
                    strings.eventsSelect}
                </button>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  );
}
